import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";

import SingleMediaDropzone from "sulu-media-bundle/components/SingleMediaDropzone";
import MediaUploadStore from "sulu-media-bundle/stores/MediaUploadStore";
import userStore from "sulu-admin-bundle/stores/userStore";

import styles from "./document-upload.module.scss";
import { ResourceRequester } from "sulu-admin-bundle/services";

@observer
class CustomDocumentUpload extends React.Component {
    locale = this.props.formInspector.locale
        ? this.props.formInspector.locale
        : observable.box(userStore.contentLocale);

    mediaUploadStore = new MediaUploadStore(this.props.value, this.locale);

    showTitle = this.props.schemaOptions.title?.value || false;

    state = {
        media: null,
        loading: false,
    };

    componentDidMount() {
        if (this.showTitle && this.props.value) {
            this.fetchMedia();
        }
    }

    handleDrop = (file) => {
        const collectionId = this.props.schemaOptions?.collection_id?.value;

        this.mediaUploadStore
            .create(collectionId, file)
            .then((data) => {
                this.props.onChange(data);
                this.props.onFinish();
            })
            .catch((error) => {
                console.error(error);
            });
    };

    fetchMedia = async () => {
        this.setState({ loading: true });
        try {
            const data = await ResourceRequester.get('media', {
                id: this.props.value.id,
                locale: this.locale.get(),
            });

            this.setState({ media: {title: data['title']} });
        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const title = this.state.media?.title;

        return (
            <div className={styles["custom-document"]}>
                <SingleMediaDropzone
                    emptyIcon="su-document"
                    uploading={this.mediaUploadStore.uploading}
                    progress={this.mediaUploadStore.progress}
                    onDrop={this.handleDrop}
                    disabled={this.props.disabled}
                    mimeType={this.mediaUploadStore.media?.mimeType}
                />
                {this.showTitle && <div className={styles["document-title"]}>{title}</div>}
            </div>
        );
    }
}

export default CustomDocumentUpload;
